//#region stateSection
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import swal from "sweetalert";

import DatePicker from "react-datepicker";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import {
  CheckPermission,
  LoadingSpinner,
  convertToDateString,
  customOption,
  customSingleValue,
} from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { GetLanguageString } from "../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../helper/Method";
import { addMember } from "../member/ApiMember";
import SearchAutoComplete from "../shared/SearchAutoComplete";
import SelectUnit from "../shared/SelectUnit";
import { ApiFund } from "./ApiFund";
import { ApiFinance } from "./ApiFinance";
//#endregion stateSection
const AddInfaqCashInHand = ({ history }) => {
  //#region stateDeclare
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));

  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [recipientType, setRecipientType] = useState("rafiq"); // 'rafiq' | 'registered' | 'unregistered'
  const [ahbabOptions, setAhbabOptions] = useState([]);
  const [selectedHabib, setSelectedHabib] = useState("");
  const [unregisteredHabibName, setUnregisteredHabibName] = useState("");
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
    includeSubUnit: false,
  });
  const unitId = values.unit.value;
  const [errors, setErrors] = useState({ selectedMember: "" });
  const fieldColSize = 3; // change this value to resize form columns uniformly
  let membersList = [];
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fundValues, setFundValues] = useState({});
  const [infaqHeads, setInfaqHeads] = useState([]);
  const [selectedInfaqHead, setSelectedInfaqHead] = useState(null);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [memberId, setMemberId] = useState(0);
  const [receiptType, setReceiptType] = useState("physical");

  //#endregion stateDeclare

  //#region useEffectSection

  useEffect(() => {
    let currentDate = new Date();
    let tempYear = currentDate.getFullYear();
    let tempMonth = currentDate.getMonth() + 1;

    setFundValues({
      memberId:
        recipientType === "rafiq"
          ? selectedMember?.value || null
          : recipientType === "registered"
            ? memberId || null
            : null,
      name:
        recipientType === "rafiq"
          ? selectedMember?.label || ""
          : recipientType === "registered"
            ? selectedHabib || ""
            : unregisteredHabibName || "",
      includeSubUnit: values.includeSubUnit || false,
      unitId: unitId,
      date: currentDate,
      month: tempMonth,
      year: tempYear,
      receiptNumber: "",
      amount: null,
      memo: "",
      codeId: selectedInfaqHead?.value,
    });
  }, [
    unitId,
    selectedMember,
    selectedInfaqHead,
    recipientType,
    selectedHabib,
    unregisteredHabibName,
    values.includeSubUnit,
    memberId,
  ]);

  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetFinanceCategoryAccountsByCode("infaq")
      .then((res) => {
        if (res?.data) {
          setInfaqHeads(res.data);

          // default select first one
          if (res.data.length > 0) {
            setSelectedInfaqHead(res.data[0]);
            setFundValues((prev) => ({
              ...prev,
              codeId: res.data[0].value,
            }));
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        swal({ title: err, icon: "error", buttons: "OK" });
        console.error(err);
      });
  }, []);

  useEffect(() => {
    addMember()
      .getUnitMembersForSelecting(values.unit.value, values.includeSubUnit)
      .then((res) => {
        setMembers(res.data);
        if (res.data.length !== 0) {
          setSelectedMember({
            value: res.data[0].id,
            label: res.data[0].name + " - " + res.data[0].regNo,
          });
          setErrors({ member: "" });
        } else {
          setSelectedMember({});
        }
        setLoading(false);
      })
      .catch((err) => {
        swal({ title: err, icon: "error", buttons: "OK" });
        console.error(err);
      });
  }, [values]);

  useEffect(() => {
    if (selectedHabib && !selectedHabib.includes("/")) {
      setLoadingSearch(true);

      const timeoutId = setTimeout(() => {
        addMember()
          .getUnitParticipantsByType(
            values.unit.value,
            values.includeSubUnit,
            "habib",
            selectedHabib,
          )
          .then((res) => {
            if (res.data) {
              setAhbabOptions(res.data);
            }
            setLoadingSearch(false);
          })
          .catch((err) => {
            swal({ title: err, icon: "error", buttons: "OK" });
            console.error(err);
            setLoadingSearch(false);
          });
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [selectedHabib, values]);

  //#endregion useEffectSection

  const handleInfaqHeadChange = (selected) => {
    setSelectedInfaqHead(selected);

    setFundValues((prev) => ({
      ...prev,
      codeId: selected ? selected.value : "",
    }));

    setErrors((prev) => ({
      ...prev,
      selectedInfaqHeadErrorMsg: selected
        ? ""
        : "Please select an Account Head",
    }));
  };

  //#region functionHandler

  if (members.length !== 0) {
    members.forEach((m) =>
      membersList.push({ value: m.id, label: m.name + " - " + m.regNo }),
    );
  }

  const validate = () => {
    let temp = {};
    temp.month = fundValues.month ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_month_error" />
    );
    temp.year = fundValues.year ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_select_year_error" />
    );
    temp.receiptNumber =
      receiptType === "physical" ? (
        fundValues.receiptNumber ? (
          ""
        ) : (
          <GetLanguageString props="common_field_required_error" />
        )
      ) : (
        ""
      );
    temp.date = selectedDate ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_date_paid_error" />
    );
    temp.amount = fundValues.amount ? (
      ""
    ) : (
      <GetLanguageString props="funds_add_fund_amount_paid_error" />
    );
    // Validate based on recipient type
    if (recipientType === "rafiq") {
      temp.selectedMember =
        selectedMember && selectedMember.value ? (
          ""
        ) : (
          <GetLanguageString props="funds_member_error_message" />
        );
    } else if (recipientType === "registered") {
      temp.selectedHabib =
        selectedHabib && memberId ? (
          ""
        ) : (
          <GetLanguageString props="funds_habib_error_message" />
        );
    } else {
      // unregistered
      temp.unregisteredHabibName = unregisteredHabibName ? (
        ""
      ) : (
        <GetLanguageString props="funds_unregistered_habib_name_error_message" />
      );
    }

    // New: validate both Infaq Head and Bank Account (only for rafiq flow)
    temp.selectedInfaqHeadErrorMsg =
      recipientType === "rafiq" ? (
        selectedInfaqHead ? (
          ""
        ) : (
          <GetLanguageString props="funds_add_fund_account_head_error" />
        )
      ) : (
        ""
      );

    // Merge with previous errors to avoid wiping other fields accidentally
    setErrors((prev) => ({
      ...prev,
      ...temp,
    }));

    // Return true only if all error messages are empty strings
    return Object.values(temp).every((x) => x === "");
  };

  const handleChangeMember = (record) => {
    setSelectedMember(record);
    setErrors((prev) => ({ ...prev, selectedMember: "" }));
  };

  const handleRecipientTypeChange = (e) => {
    const val = e.target.value;
    setRecipientType(val);
    // reset related fields
    setErrors({});
    if (val === "rafiq") {
      // nothing
    } else if (val === "registered") {
      setSelectedMember(null);
    } else {
      setSelectedMember(null);
      setSelectedHabib(null);
      setUnregisteredHabibName("");
    }
  };

  const handleUnregisteredHabibName = (e) => {
    setUnregisteredHabibName(e.target.value);
    setErrors((prev) => ({ ...prev, unregisteredHabibName: "" }));
  };

  const handleReceiptNumber = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFundValues((prev) => ({
      ...prev,
      receiptNumber: value,
    }));
    setErrors((prev) => ({ ...prev, receiptNumber: "" }));
  };

  const handleReceiptTypeChange = (e) => {
    const value = e.target.value;
    setReceiptType(value);
    if (value === "digital") {
      setFundValues((prev) => ({
        ...prev,
        receiptNumber: "",
      }));
      setErrors((prev) => ({ ...prev, receiptNumber: "" }));
    }
  };

  const handleInputChangeDate = (value) => {
    setSelectedDate(value);
    setErrors((prev) => ({ ...prev, date: "" }));
  };

  const handleMemoChange = (e) => {
    setFundValues((prev) => ({
      ...prev,
      memo: e.target.value,
    }));
  };

  // It will handle change in Amount
  const handleAmountChange = (e) => {
    let { value } = e.target;
    value = value.replace(/\D/g, "");
    setFundValues((prev) => ({
      ...prev,
      amount: value,
    }));
    setErrors((prev) => ({ ...prev, amount: "" }));
  };

  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValues({
      ...values,
      includeSubUnit: v,
    });
  };

  const handleOnSelect = (item) => {
    var str = item?.name;
    let remove = str.split(" - ").pop();
    let requiredName = str.replace(" - " + remove, "   ");
    setSelectedHabib(requiredName + " - " + remove.replace("/", " "));
    setMemberId(item.id);
    setErrors({
      ...errors,
      selectedHabib: "",
    });
    setAhbabOptions([]);
  };

  const handleSubmit = async (addOther = false) => {
    // run validation first (this also sets appropriate errors)
    if (!validate()) {
      // validation failed: don't proceed
      return;
    }
    setLoading(true);

    // Build payload explicitly based on recipient type to ensure correct fields
    const override = {};
    // codeId only applicable for Rafiq flow
    override.codeId = selectedInfaqHead?.value ?? fundValues.codeId ?? 0;
    if (recipientType === "rafiq") {
      override.memberId = selectedMember?.value ?? null;
      override.isRafiq = true;
    } else if (recipientType === "registered") {
      const regMemberId = memberId || null;
      const regName = selectedHabib
        ? selectedHabib
        : typeof selectedHabib === "string"
          ? selectedHabib
          : "";
      override.memberId = regMemberId;
      override.name = regName.includes("-")
        ? regName.substring(0, regName.indexOf("-")).trim()
        : regName.trim();

      override.isRafiq = false;
    } else {
      // unregistered
      override.memberId = null; // store NULL rafiq id locally
      override.name = unregisteredHabibName ?? "";
      override.isRafiq = false;
    }
    override.includeSubUnits = values.includeSubUnit || false;
    const payload = {
      ...fundValues,
      ...override,
      date: convertToDateString(selectedDate),
      month: selectedDate ? selectedDate.getMonth() + 1 : fundValues.month,
      year: selectedDate ? selectedDate.getFullYear() : fundValues.year,
      generateDigitalReceipt: receiptType === "digital",
    };
    try {
      const res = await ApiFund().addFund(payload);
      if (res.data.statusCode === "200") {
        swal({
          title: t("member_member_detail_fund_added"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "success",
          buttons: "OK",
        });

        if (addOther) {
          // 🔁 reset only necessary fields
          setFundValues((prev) => ({
            ...prev,
            receiptNumber: "",
            amount: "",
            memo: "",
          }));
          setSelectedDate(null);
        } else {
          history.goBack();
        }
      } else {
        swal({
          title: t(res.data.message) || t("something_went_wrong"),
          className: GetSelectedLanguage() === "en" ? "" : "ur",
          icon: "error",
          buttons: "OK",
        });
      }
    } catch (err) {
      swal({
        title: err,
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "error",
        buttons: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  //#endregion functionHandler
  return (
    <>
      <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="funds_add_fund" />}</h5>
            <Button
              className={GetCustomStyles().btn_style}
              color="white"
              size="xs"
              onClick={() => history.goBack()}
            >
              {" "}
              <IoArrowBackSharp
                color="#18A689"
                size={15}
                style={{ marginRight: 5, marginBottom: 1 }}
              />
              {<GetLanguageString props="courses_participants_back" />}
            </Button>
          </div>

          <div className="ibox-content">
            {!loading ? (
              <>
                <Row>
                  <SelectUnit
                    values={values}
                    setValues={setValues}
                    unitId={values.unit.value}
                  />
                  <Col md="4">
                    <FormGroup check>
                      <Label check for="subUnit">
                        <Input
                          id="subUnit"
                          type="checkbox"
                          name="includeSubUnit"
                          checked={values.includeSubUnit}
                          value={!values.includeSubUnit}
                          onChange={handleSubUnits}
                        />
                        {
                          <GetLanguageString props="member_search_member_sub_unit" />
                        }
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
                <hr></hr>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <div>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="rafiq"
                              checked={recipientType === "rafiq"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="rafiq" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="registered"
                              checked={recipientType === "registered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="registered_habib" />}
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check style={{ marginRight: 24 }}>
                            <Input
                              type="radio"
                              name="recipientType"
                              value="unregistered"
                              checked={recipientType === "unregistered"}
                              onChange={handleRecipientTypeChange}
                            />{" "}
                            {<GetLanguageString props="unregistered_habib" />}
                          </Label>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={fieldColSize}>
                    <FormGroup>
                      {/* Rafiq: existing member select */}
                      {recipientType === "rafiq" && (
                        <>
                          {" "}
                          <Label className="col-form-label">
                            {<GetLanguageString props="funds_select_member" />}
                          </Label>
                          <Select
                            components={{
                              Option: customOption,
                              SingleValue: customSingleValue,
                            }}
                            value={selectedMember}
                            options={membersList}
                            className="basic-single"
                            classNamePrefix="select"
                            onChange={handleChangeMember}
                          />
                          {errors.selectedMember && (
                            <h4 className="text-error">
                              {errors.selectedMember}
                            </h4>
                          )}
                        </>
                      )}

                      {/* Registered Habib: show ahbab dropdown */}
                      {recipientType === "registered" && (
                        <>
                          {" "}
                          <Label className="col-form-label">
                            {<GetLanguageString props="member_search_habib" />}
                          </Label>
                          <SearchAutoComplete
                            members={ahbabOptions}
                            setMembers={setAhbabOptions}
                            setName={setSelectedHabib}
                            name={selectedHabib}
                            type={"habib"}
                            loading={loadingSearch}
                            placeholder={t("common_search_by_name")}
                            handleOnSelect={handleOnSelect}
                            calledFrom="mudaris"
                          />
                          {errors.selectedHabib && (
                            <h4 className="text-error">
                              {errors.selectedHabib}
                            </h4>
                          )}
                        </>
                      )}

                      {/* Unregistered Habib: free text name input */}
                      {recipientType === "unregistered" && (
                        <>
                          <Label className="col-form-label">
                            {<GetLanguageString props="common_name" />}
                          </Label>
                          <Input
                            type="text"
                            value={unregisteredHabibName}
                            onChange={handleUnregisteredHabibName}
                          />
                          {errors.unregisteredHabibName && (
                            <h4 className="text-error">
                              {errors.unregisteredHabibName}
                            </h4>
                          )}
                        </>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={fieldColSize}>
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="funds_add_fund_date_paid" />}
                      </Label>
                      <DatePicker
                        minDate={
                          new Date(
                            new Date().getFullYear(),
                            new Date().getMonth(),
                            1,
                          )
                        }
                        maxDate={new Date()}
                        placeholderText="dd/mm/yyyy"
                        className="form-control no-drag"
                        dateFormat="dd/MM/yyyy"
                        selected={selectedDate}
                        onChange={handleInputChangeDate}
                      />
                      {errors.date && (
                        <h4 className="text-error">{errors.date}</h4>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={fieldColSize}>
                    <FormGroup>
                      <Label className="col-form-label">
                        <GetLanguageString props="fund_account_head" />
                      </Label>
                      <Select
                        options={infaqHeads}
                        value={selectedInfaqHead}
                        placeholder="Select infaq head"
                        onChange={handleInfaqHeadChange}
                        className="basic-single no-drag"
                        classNamePrefix="select"
                      />

                      {errors.selectedInfaqHeadErrorMsg && (
                        <h4 className="text-error">
                          {errors.selectedInfaqHeadErrorMsg}
                        </h4>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Add Amount for the fund */}
                  <Col md={fieldColSize}>
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="funds_add_fund_amount" />}
                      </Label>
                      <Input
                        autoFocus
                        type="text"
                        className="no-drag"
                        value={fundValues.amount}
                        onChange={handleAmountChange}
                      />
                      {errors.amount && (
                        <h4 className="text-error no-drag">{errors.amount}</h4>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={fieldColSize}>
                    <FormGroup>
                      <div
                        className="col-form-label d-flex align-items-center"
                        style={{ gap: 16 }}
                      >
                        <Label check className="mb-0">
                          <Input
                            type="radio"
                            name="receiptTypeCashInHand"
                            value="physical"
                            checked={receiptType === "physical"}
                            onChange={handleReceiptTypeChange}
                          />{" "}
                          {<GetLanguageString props="funds_physical_receipt" />}
                        </Label>
                        <Label check className="mb-0">
                          <Input
                            type="radio"
                            name="receiptTypeCashInHand"
                            value="digital"
                            checked={receiptType === "digital"}
                            onChange={handleReceiptTypeChange}
                          />{" "}
                          {<GetLanguageString props="funds_digital_receipt" />}
                        </Label>
                      </div>
                      <Input
                        autoFocus
                        type="text"
                        className="no-drag"
                        value={fundValues.receiptNumber}
                        onChange={handleReceiptNumber}
                        disabled={receiptType === "digital"}
                      />
                      {errors.receiptNumber && (
                        <h4 className="text-error">{errors.receiptNumber}</h4>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={fieldColSize}>
                    <FormGroup>
                      <Label className="col-form-label">
                        {<GetLanguageString props="transactions_memo" />}
                      </Label>
                      <Input
                        type="text"
                        className="no-drag"
                        value={fundValues.memo}
                        onChange={handleMemoChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="9"></Col>
                  <Col md={fieldColSize} className="text-end">
                    {CheckPermission("CanAddFunds") ? (
                      <>
                        <Button color="white" onClick={() => history.goBack()}>
                          {<GetLanguageString props="common_cancel" />}
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          color="primary"
                          onClick={() => handleSubmit(false)}
                        >
                          {<GetLanguageString props="common_save" />}
                        </Button>
                        &nbsp;&nbsp;
                        <Button
                          color="success"
                          onClick={() => handleSubmit(true)}
                        >
                          {
                            <GetLanguageString props="funds_add_fund_and_add_other" />
                          }
                        </Button>
                      </>
                    ) : null}
                  </Col>
                </Row>
              </>
            ) : (
              LoadingSpinner()
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(AddInfaqCashInHand);
